import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const stockSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string())
})

export default stockSchema
